import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import customerService from "../../services/customerService";
import droneService from "../../services/droneService";
const ChangeClientForm = ({ droneId, customerId, closeChangeClient }) => {
    const { t } = useTranslation();
    const [customers, setCustomers] = useState([]);
    const { register, handleSubmit } = useForm({
        defaultValues: {
            customerId: customerId !== null && customerId !== void 0 ? customerId : "",
        },
    });
    const onSubmit = (data) => {
        droneService
            .updateDroneCustomer(droneId, data.customerId)
            .then((data) => {
            closeChangeClient();
        })
            .catch();
    };
    useEffect(() => {
        customerService
            .getCustomers(1, 9999)
            .then((data) => {
            setCustomers(data.items);
            //TODO setPagination
        })
            .catch();
    }, []);
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsx("label", { htmlFor: "customerId", children: t("changeClientForm.label") }), _jsx("select", Object.assign({ id: "customerId" }, register("customerId", { required: true }), { children: customers.map((customer) => (_jsx("option", { value: customer.id, children: customer.name }, customer.id))) })), _jsx("input", { type: "submit", value: t("changeClientForm.submit") })] }));
};
export default ChangeClientForm;
